import fetch, { METHOD } from 'Util/fetch';
import { useConfig } from 'Context/ConfigContext';

const useCookieSession = () => {
  const { userApi } = useConfig();
  const retrieveCookieSession = async () => {
    await fetch(`${userApi}/me/session`, null, METHOD.GET, null, {
      parseJson: true,
      isForceIncludeCredentials: true,
      includeContentType: true,
      isRedirect: false,
    });
  };

  return { retrieveCookieSession };
};

export default useCookieSession;
